import React, { useContext, useEffect, useState} from 'react'
import Axios from 'axios'

import Conversations from '../conversations/Conversations'
import { MessengerContext } from '../../context/MessengerContext'

import './chatMenu.css'
import { AuthContext } from '../../context/AuthContext'
import SkeletonConversations from '../skeletonConversations/SkeletonConversations'
import EmptyStateConversations from '../emptyStateConversations/EmptyStateConversations'

const ChatMenu = () => {
  
  //Initializing the states
  const [conversations, setConversations] = useState([])
  const [conversation, setConversation] = useContext(MessengerContext)
  const {user} = useContext(AuthContext)
  
  const API = process.env.REACT_APP_API_URL

  //Handle Change
  const handleChange = (e) => {
    const searchInput = e.target.value
  }
  useEffect(() => {
    const fetchConversations = async () => {
      setConversation({...conversation, isFetching: true})
      const {data: {conversations}} = await Axios.get(API + `conversations/${user._id}`)
      // const communicatorId = conversations[0]?.members.find((id) => id !== user._id)
      // const {data: {messages}} = await Axios.get(API + `messages/${conversations[0]?._id}`)
      // const {data: {user: communicator}} = await Axios.get(API + `users/?userId=${communicatorId}`)
      setConversations(conversations)
      // setConversation({...conversation, conversation: conversations[0], messages: messages, communicator: communicator})
      setConversation({...conversation, isFetching: false})
    }
    fetchConversations()
  }, [])
  return (
    <div className="chatMenu">
        <div className="chatMenuWrapper">
            {/* <div className="chatMenuTop">
              <div className="searchBarWrapper">
                <input id="friendsSearchBar" className='searchBar' type="text" placeholder='Search in conversations' onChange={handleChange}/>
              </div>
            </div> */}
            <div className="chatMenuBottom">
              {
                conversation.isFetching 
                ?
                  <SkeletonConversations />
                :
                  conversations.length
                  ?
                    <Conversations conversations={conversations}/>
                  :
                    <EmptyStateConversations />
              }
            </div>
        </div>
    </div>
  )
}

export default ChatMenu